import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      profile: 'main/profile'
    })
  },

  methods: {
    isFeatureEnabled (flag) {
      return !!this.profile.featureFlags?.includes(flag)
    }
  }
}
